// Mapea los errores de límite de plan a mensajes de upsell.
// Las RPC de Postgres lanzan la excepción con `using hint = '<codigo>'`, que
// supabase-js expone en `error.hint`. Ver supabase/sql/billing-plan.sql.

export type PlanLimitHint =
  | 'member_limit_reached'
  | 'free_space_limit'
  | 'storage_quota_reached'
  | 'file_too_large';

const HINTS: PlanLimitHint[] = [
  'member_limit_reached',
  'free_space_limit',
  'storage_quota_reached',
  'file_too_large',
];

/** Devuelve el código de límite si el error es un límite de plan; si no, null. */
export function planLimitHint(err: unknown): PlanLimitHint | null {
  const hint = (err as { hint?: unknown } | null | undefined)?.hint;
  return typeof hint === 'string' && (HINTS as string[]).includes(hint)
    ? (hint as PlanLimitHint)
    : null;
}

export const PLAN_LIMIT_COPY: Record<PlanLimitHint, { title: string; body: string }> = {
  member_limit_reached: {
    title: 'Has alcanzado el límite del plan Free',
    body: 'El plan Free permite hasta 5 usuarios por espacio. Mejora a Team para invitar a todo tu equipo sin límite.',
  },
  free_space_limit: {
    title: 'Solo un espacio en el plan Free',
    body: 'El plan Free incluye 1 espacio de trabajo. Mejora a Team para crear todos los espacios que necesites.',
  },
  storage_quota_reached: {
    title: 'Almacenamiento del plan Free completo',
    body: 'Has alcanzado los 2 GB del plan Free. Mejora a Team para ampliar a 100 GB por espacio.',
  },
  file_too_large: {
    title: 'Archivo demasiado grande para el plan Free',
    body: 'El plan Free admite archivos de hasta 25 MB. Mejora a Team para subir archivos de hasta 200 MB.',
  },
};
